module.exports = __webpack_public_path__ + "static/media/20231026-DSC_5015.fe043f46.jpg";